import React from 'react'
import { Row } from 'react-bootstrap'
import styles from './section-heading.module.scss'

const SectionHeading = ({
  preTitle,
  title,
  description,
  className,
  center,
}) => {
  return (
    <Row className={`${className} ${center ? 'text-center' : 'default'}`}>
      {preTitle ? <h5>{preTitle}</h5> : ''}
      <h1 className='mb-2'>{title}</h1>
      {description ? <p className='mb-4 mt-2 italic'>{description}</p> : ''}
    </Row>
  )
}

export default SectionHeading
